import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Sparkles, TrendingUp, Wrench, ShieldCheck, Palette, Zap, Plug, ArrowLeft } from "lucide-react";

const CAT = {
  new: { icon: Sparkles, color: "#EAB308", fr: "NOUVEAU", en: "NEW" },
  improvement: { icon: TrendingUp, color: "#4c9dff", fr: "AMÉLIORÉ", en: "IMPROVED" },
  fix: { icon: Wrench, color: "#22c55e", fr: "CORRIGÉ", en: "FIXED" },
  security: { icon: ShieldCheck, color: "#dc143c", fr: "SÉCURITÉ", en: "SECURITY" },
  design: { icon: Palette, color: "#EAB308", fr: "DESIGN", en: "DESIGN" },
  automation: { icon: Zap, color: "#4c9dff", fr: "AUTOMATISATION", en: "AUTOMATION" },
  integration: { icon: Plug, color: "#22c55e", fr: "INTÉGRATION", en: "INTEGRATION" },
};

export default function NouveautesPage() {
  const { lang } = useI18n();
  const navigate = useNavigate();
  const [releases, setReleases] = useState([]);
  const L = (fr, en) => (lang === "en" ? en : fr);

  useEffect(() => {
    api.get("/releases/history").then(({ data }) => setReleases(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen progere-bg text-white px-4 py-12" data-testid="nouveautes-page">
      <div className="mx-auto max-w-3xl">
        <button onClick={() => navigate(-1)} className="mb-6 inline-flex items-center gap-2 text-sm text-white/50 hover:text-white" data-testid="nouveautes-back">
          <ArrowLeft className="w-4 h-4" /> {L("Retour", "Back")}
        </button>
        <h1 className="text-4xl font-black">
          <span className="text-white">{L("Nouveautés", "What's")}</span> <span className="text-[#EAB308]">{L("& mises à jour", "new")}</span>
        </h1>
        <p className="mt-2 text-white/55">
          <span className="pg-pro font-black">PRO</span><span className="pg-gere font-black">GÈRE</span> <span className="progere-brand-module font-black">CORE</span> — {L("historique des versions", "release history")}
        </p>

        <div className="mt-10 space-y-8">
          {releases.map((rel) => {
            const title = lang === "en" ? rel.title_en || rel.title_fr : rel.title_fr;
            const date = rel.published_at ? new Date(rel.published_at).toLocaleDateString(lang === "en" ? "en-CA" : "fr-CA", { year: "numeric", month: "long", day: "numeric" }) : "";
            return (
              <div key={rel.id} className="rounded-xl border border-white/10 bg-[#111217] p-6" data-testid={`release-${rel.version}`}>
                <div className="flex items-center gap-3">
                  <span className="rounded px-2.5 py-1 text-[11px] font-black text-black bg-[#EAB308]">v{rel.version}</span>
                  <span className="text-xs text-white/40">{date}</span>
                </div>
                <h2 className="mt-3 text-lg font-bold text-white">{title}</h2>
                <div className="mt-4 space-y-2">
                  {(rel.items || []).map((it, i) => {
                    const c = CAT[it.category] || CAT.new;
                    const Icon = c.icon;
                    const itTitle = lang === "en" ? it.title_en || it.title_fr : it.title_fr;
                    return (
                      <div key={i} className="flex items-start gap-3">
                        <div className="flex h-6 w-6 shrink-0 items-center justify-center rounded" style={{ background: `${c.color}18` }}>
                          <Icon className="w-3.5 h-3.5" style={{ color: c.color }} />
                        </div>
                        <p className="text-sm text-white/80"><span className="font-bold" style={{ color: c.color }}>{L(c.fr, c.en)}</span> — {itTitle}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
          {releases.length === 0 && <p className="text-white/40">{L("Aucune version publiée.", "No published releases.")}</p>}
        </div>
      </div>
    </div>
  );
}
